import React from 'react'
import { Skeleton, TextSkeleton } from '.'

export const ProductCardGallerySkeleton = ({ noAnimation = false }: { noAnimation?: boolean }) => {
  return (
    <Skeleton
      shade="light"
      noAnimation={noAnimation}
      className="d-flex flex-column align-items-center u-mb-16 u-px-16 u-py-16">
      <Skeleton withLogo height={140} noAnimation={noAnimation}></Skeleton>
      <div className="u-w-100">
        <div className="u-mb-64">
          <TextSkeleton type="p" noAnimation={noAnimation} />
        </div>
        <Skeleton shade="dark" height={36} noAnimation={noAnimation}></Skeleton>
      </div>
    </Skeleton>
  )
}
